'use strict';

exports.__esModule = true;

var _Rule = require('./Rule');

var _Rule2 = _interopRequireDefault(_Rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Create a new instance of Perimeter.
 */
var createRule = function createRule() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return new (Function.prototype.bind.apply(_Rule2.default, [null].concat(args)))();
};

exports.default = createRule;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/createRule.js
// module id = +EFI
// module chunks = 0